/* eslint-disable react/jsx-wrap-multilines */
import React, { createElement, useEffect, useMemo, useRef, useState } from 'react';
import { Element, Link } from 'react-scroll';
import { useToggle } from 'react-use';
import styled, { createGlobalStyle } from 'styled-components';
import { Panel, Tabs } from 'zarm';
import './index.less';

const ScrollTabs = ({
  list,
  height
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  const onSetActive = key => setTabIndex(list.findIndex(item => item.key === key));

  if (list.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabsStyled, null));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabsStyled, null), /*#__PURE__*/React.createElement(Tabs, {
    scrollable: true,
    value: tabIndex,
    direction: "horizontal"
  }, list.map(item => /*#__PURE__*/React.createElement(Panel, {
    title: /*#__PURE__*/React.createElement(Link, {
      spy: true,
      smooth: true,
      to: item.key,
      offset: -height,
      duration: 420,
      onSetActive: onSetActive
    }, item.value)
  }))));
};

export default function StickyScroll({
  children,
  list,
  contentList = [],
  height = 40,
  getSticky
}) {
  // 对 contentList 按照 list[].id 分组
  const contents = useMemo(() => {
    const dataSource = [];

    if (list.length === 0) {
      dataSource.push({
        key: 'unin',
        items: contentList.map(i => i.element)
      });
      return dataSource;
    }

    for (let i = 0; i < list.length; i++) {
      var _list;

      const currentListItem = list[i];
      const {
        key
      } = currentListItem;
      const nextKey = (_list = list[i + 1]) === null || _list === void 0 ? void 0 : _list.key;
      let start = false;
      const contentItem = {
        key,
        items: []
      };
      contentList.forEach(contentListItem => {
        if (contentListItem.id === key) {
          start = true;
        } else if (contentListItem.id === nextKey) {
          start = false;
        }

        if (start) {
          contentItem.items.push(contentListItem.element);
        }
      });
      dataSource.push(contentItem);
    }

    return dataSource;
  }, [list, contentList]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sticky, {
    height: height
  }, ({
    isSticky
  }) => {
    getSticky && getSticky(isSticky);
    return /*#__PURE__*/React.createElement(StickyTabs, {
      isSticky: isSticky
    }, /*#__PURE__*/React.createElement(ScrollTabs, {
      list: list,
      height: height
    }));
  }), /*#__PURE__*/React.createElement("div", null, contents.map(({
    key,
    items
  }) => /*#__PURE__*/React.createElement(Element, {
    key: key,
    name: key
  }, items))), children);
}
const TabsStyled = createGlobalStyle`
  .za-tabs__tab--active a {
    color: var(--theme-primary);
  }
`;

const Sticky = ({
  children,
  height = 0
}) => {
  const ref = useRef();
  const [isSticky, setIsSticky] = useToggle(false);
  useEffect(() => {
    const scroll = () => {
      const {
        top
      } = ref.current.getBoundingClientRect();
      setIsSticky(top <= 0);
    };

    window.addEventListener('scroll', scroll);
    return () => window.removeEventListener('scroll', scroll);
  }, [setIsSticky]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      height: isSticky ? height : 0
    }
  }), /*#__PURE__*/createElement(children, {
    isSticky
  }));
};

const StickyTabs = styled.div`
  ${props => props.isSticky ? `
    position: fixed;
    z-index: 10;
    width: 100%;
    top: 0;
    background-color: white;
  ` : ''}
`;